<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';

import { headerDesktop, headerMobile } from '@/assets/images';

import { router, routes } from '@/router';
import { useUserStore } from '@/stores';

const userStore = useUserStore();
const { loggedIn } = storeToRefs(userStore);

const logout = () => {
  userStore.resetUser();
  router.push({ name: routes.home.name });
};

const currentRoute = useRoute().name;
</script>

<template>
  <header
    :class="[
      'relative flex flex-wrap justify-between items-start pt-4 w-full md:flex-nowrap max-w-screen-3xl 3xl:mx-auto',
      currentRoute === 'home' ? 'h-[34rem] px-4 md:h-[38rem] 2xl:px-80' : 'md:px-4 mb-14 md:mb-0'
    ]"
  >
    <img
      v-if="currentRoute === 'home'"
      :src="headerMobile"
      :alt="$t('navigation.header.imgAlt')"
      loading="lazy"
      class="absolute left-0 top-0 z-0 w-full object-cover h-full md:hidden"
    />
    <img
      v-if="currentRoute === 'home'"
      :src="headerDesktop"
      :alt="$t('navigation.header.imgAlt')"
      loading="lazy"
      class="hidden absolute max-w-none top-[10rem] right-[14%] z-0 h-[30rem] object-contain md:block"
    />
    <Logo :class="['flex-shrink-0 z-10', currentRoute === 'home' ? '' : 'w-28 h-28']" />
    <h1
      v-if="router.currentRoute.value.name === routes.home.name"
      class="h1 self-end text-center order-2 grow w-full z-10 mb-12 md:mb-6 md:order-none md:w-auto md:max-w-[42rem] md:absolute md:text-left md:self-center"
    >
      {{ $t('home.title') }}
    </h1>
    <div class="flex flex-col items-end z-10 mt-8 md:self-start gap-4 flex-shrink-0">
      <RouterLink v-if="loggedIn" :to="{ name: routes.login.name }" class="button">
        {{ $t('navigation.header.candidateArea') }}
      </RouterLink>

      <div class="flex items-center gap-4 z-10">
        <button v-if="loggedIn" type="button" @click="logout">
          {{ $t('logout') }}
        </button>

        <RouterLink
          v-if="!loggedIn && router.currentRoute.value.name !== routes.login.name"
          :to="{ name: routes.login.name }"
        >
          {{ $t('navigation.header.login') }}
        </RouterLink>
        <LanguageSwitcher />
      </div>
    </div>
  </header>
</template>